import React from "react";

export default function OfficeGalleryView(props) {
  return (
    <div className="col-lg-3 col-md-4 col-sm-6 col-12 px-2 mb-4 p-0 ">
      <img src={props.img} alt="Office View" className="img-fluid" />
    </div>
  );
}
